import { useState } from 'react';
import { useSafeLayoutEffect } from './use-safe-layout-effect';

/**
 * Hook that determines if current device
 * matches supplied media query string.
 * @param queryInput Media query string
 */
export var useMediaQuery = queryInput => {
  var query = queryInput.replace(/^@media( ?)/m, '');
  var [matches, setMatches] = useState(() => {
    return matchMedia(query).matches;
  });
  useSafeLayoutEffect(() => {
    var queryList = matchMedia(query);
    setMatches(queryList.matches);
    var onMatchMediaChange = e => {
      setMatches(e.matches);
    };
    queryList.addEventListener('change', onMatchMediaChange);
    return () => {
      queryList.removeEventListener('change', onMatchMediaChange);
    };
  }, [query, setMatches]);
  return matches;
};